
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * AccountingType enum
 */
class AccountingType {
  /**
   * Initialize enum with a given value
   * @param {AccountingType|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof AccountingType) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!AccountingType}
   * @param {!AccountingType} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof AccountingType)) {
      throw new TypeError('Instance of AccountingType is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!AccountingType}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!AccountingType}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === AccountingType.GROSS.value) {
      return 'GROSS'
    }
    if (this.value === AccountingType.NET.value) {
      return 'NET'
    }
    if (this.value === AccountingType.EXCHANGE.value) {
      return 'EXCHANGE'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!AccountingType}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!AccountingType}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!AccountingType} Created enum
   */
  static fromObject (other) {
    return new AccountingType(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
AccountingType.GROSS = new AccountingType(0 + 0)
// noinspection PointlessArithmeticExpressionJS
AccountingType.NET = new AccountingType(0 + 1)
// noinspection PointlessArithmeticExpressionJS
AccountingType.EXCHANGE = new AccountingType(0 + 2)

export { AccountingType };

/**
 * Fast Binary Encoding AccountingType field model
 */
class FieldModelAccountingType extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelAccountingType}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 1
  }

  /**
   * Get the value
   * @this {!FieldModelAccountingType}
   * @param {AccountingType=} defaults Default value, defaults is new AccountingType()
   * @returns {!AccountingType} Result value
   */
  get (defaults = new AccountingType()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new AccountingType(this.readByte(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelAccountingType}
   * @param {!AccountingType} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeByte(this.fbeOffset, value.value)
  }
}

export { FieldModelAccountingType };
